import React from "react";
import { useTranslation } from "react-i18next";
import { selectAppData } from "@100mslive/react-sdk";
import {
  ChatIcon,
  ConnectivityIcon,
  HandIcon,
  PersonIcon,
  PoorConnectivityIcon,
} from "@100mslive/react-icons";
import { Button } from "@100mslive/react-ui";
import { hmsActions, hmsStore } from "../../hms";
import i18n from "../../lang/index";
import { APP_DATA, SIDE_PANE_OPTIONS } from "../../common/constants";

const isChatOpen = () => {
  return (
    hmsStore.getState(selectAppData(APP_DATA.sidePane)) ===
    SIDE_PANE_OPTIONS.CHAT
  );
};

const ChatAction = React.forwardRef((_, ref) => {
  const { t } = useTranslation();
  return (
    <Button
      outlined
      as="div"
      variant="standard"
      css={{ w: "max-content" }}
      onClick={() => {
        hmsActions.setAppData(APP_DATA.sidePane, SIDE_PANE_OPTIONS.CHAT);
      }}
      ref={ref}
    >
      {t("lbl_open_chat")}
    </Button>
  );
});

export const ToastConfig = {
  PEER_LIST: {
    single: function (notification) {
      if (notification.data.length === 1) {
        return {
          title: i18n.t("fm_joined", { name: notification.data[0]?.name }),
          // title: `${notification.data[0]?.name} đã tham gia`,
          icon: <PersonIcon />,
        };
      }
      return {
        title: i18n.t("fm_joined_multiple", {
          name: notification.data[notification.data.length - 1]?.name,
          number: notification.data.length - 1,
        }),
        // title: `${notification.data[notification.data.length - 1]?.name} và ${
        //   notification.data.length - 1
        // } người khác đã tham gia`,
        icon: <PersonIcon />,
      };
    },
    multiple: notifications => {
      return {
        title: i18n.t("fm_joined_multiple", {
          name: notifications[0].data.name,
          number: notifications.length - 1,
        }),
        // title: `${notifications[0].data.name} và ${
        //   notifications.length - 1
        // } người khác đã tham gia`,
        icon: <PersonIcon />,
      };
    },
  },
  PEER_JOINED: {
    single: function (notification) {
      return {
        title: i18n.t("fm_joined", { name: notification.data?.name }),

        // title: `${notification.data?.name} đã tham gia`,
        icon: <PersonIcon />,
      };
    },
    multiple: function (notifications) {
      return {
        title: i18n.t("fm_joined_multiple", {
          name: notifications[notifications.length - 1].data.name,
          number: notifications.length - 1,
        }),
        // title: `${notifications[notifications.length - 1].data.name} và ${
        //   notifications.length - 1
        // } người khác đã tham gia`,
        icon: <PersonIcon />,
      };
    },
  },
  PEER_LEFT: {
    single: function (notification) {
      return {
        title: i18n.t("fm_left", { name: notification.data?.name }),

        // title: `${notification.data?.name} rời đi`,
        icon: <PersonIcon />,
      };
    },
    multiple: function (notifications) {
      return {
        title: i18n.t("fm_left_multiple", {
          name: notifications[notifications.length - 1].data.name,
          number: notifications.length - 1,
        }),
        // title: `${notifications[notifications.length - 1].data.name} và ${
        //   notifications.length - 1
        // } người khác rời đi`,
        icon: <PersonIcon />,
      };
    },
  },
  METADATA_UPDATED: {
    single: notification => {
      return {
        title: i18n.t("fm_hands_up", { name: notification.data?.name }),
        icon: <HandIcon />,
      };
    },
    multiple: notifications => {
      return {
        title: i18n.t("fm_hands_up_multiple", {
          name: notifications[notifications.length - 1].data?.name,
          number: notifications.length - 1,
        }),
        // title: `${notifications[notifications.length - 1].data?.name} và ${
        //   notifications.length - 1
        // } người khác giơ tay`,
        icon: <HandIcon />,
      };
    },
  },
  NEW_MESSAGE: {
    single: notification => {
      return {
        title: i18n.t("fm_new_message", {
          name: notification.data?.senderName,
        }),

        // title: `Tin nhắn mới từ ${notification.data?.senderName}`,
        icon: <ChatIcon />,
        action: isChatOpen() ? null : <ChatAction />,
      };
    },
    multiple: notifications => {
      return {
        title: i18n.t("fm_new_message_multiple", {
          number: notifications.length,
        }),

        // title: `${notifications.length} tin nhắn mới`,
        icon: <ChatIcon />,
        action: isChatOpen() ? null : <ChatAction />,
      };
    },
  },
  RECONNECTED: {
    single: () => {
      return {
        title: i18n.t("lbl_connected_now"),
        icon: <ConnectivityIcon />,
        variant: "success",
        duration: 3000,
      };
    },
  },
  RECONNECTING: {
    single: message => {
      return {
        title: i18n.t("fm_offline", { message }),

        // title: `Bạn hiện đang ngoại tuyến, trong khi chúng tôi cố gắng kết nối lại, vui lòng kiểm tra kết nối internet của bạn. ${message}.

        icon: <PoorConnectivityIcon />,
        variant: "warning",
        duration: 30000,
      };
    },
  },
};
